module.exports = __webpack_public_path__ + "static/1-Tri-01-3f20219771a4d239252f956a2d68163f.png";